import { render, staticRenderFns } from "./TestInfoModal.vue?vue&type=template&id=dd45e368&scoped=true&"
import script from "./TestInfoModal.vue?vue&type=script&lang=js&"
export * from "./TestInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./TestInfoModal.vue?vue&type=style&index=0&id=dd45e368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd45e368",
  null
  
)

export default component.exports